<template>
    <div v-if="shippingMethods" class="select-shipping-method position-relative">
        <div v-if="loading" class="loader d-flex align-items-center text-center justify-content-center">
            <div class="spinner-border" role="status" aria-hidden="true"></div>
        </div>
        <div class="row" v-if="shippingMethods.length > 0">
            <div class="col-12" v-if="hasUsed">
                <p class="mb-4">Please note: Pre-Loved items will need to be collected from your school, regardless of the delivery option you choose.</p>
            </div>
            <div class="col-12 col-lg-6" v-for="shippingMethod in shippingMethods" :key="shippingMethod.id">
                <div class="shipping-method">
                    <input
                        class="shippind-method_input"
                        type="radio"
                        :id="'shipping-method-' + shippingMethod.id"
                        :value="shippingMethod.id"
                        v-model="selectedShippingMethodId"
                        @click="updateTotalCostOnSelection(shippingMethod.id)"
                    >
                    <label class="shipping-method_label" :for="'shipping-method-' + shippingMethod.id"
                            v-if="!shippingMethod.price_tbc">
                        {{ shippingMethod.display_name }} - &pound;{{
                            (shippingMethod.discount_price_inc_vat ? shippingMethod.discount_price_inc_vat : shippingMethod.price_inc_vat)|money
                        }}
                    </label>
                    <label class="shipping-method_label" :for="'shipping-method-' + shippingMethod.id" v-else>
                        {{ shippingMethod.display_name }} - TBC
                    </label>
                </div>
            </div>
            <div class="col-12">
                <p class="mb-4">{{ shippingInfo }}</p>
            </div>
        </div>
        <div v-else-if="showWarning" class="alert alert-danger">
            Sorry, there are no delivery methods available for your address.
        </div>
    </div>

</template>

<script>
import currency from "currency.js";

export default {
    data() {
        return {
            loading: true,
            selectedShippingMethodId: null,
            shippingMethods: false,
            shippingInfo: null,
            addressId: null,
            showWarning: false,
            hasUsed: false
        };
    },

    watch: {
        loading: function (val) {
            document.querySelector("button#continue").disabled = val;
        },
        selectedShippingMethodId: function (shippingMethodId) {
            if (this.shippingMethods.length > 0) {
                const activeMethod = this.shippingMethods.find(x => x.id == shippingMethodId);
                if (typeof activeMethod !== 'undefined') {
                    this.shippingInfo = activeMethod.web_info;
                    document.getElementById("shipping_method_id").value = shippingMethodId;
                    if (activeMethod.is_collection) {
                        document.getElementById("collection_info").classList.remove("d-none");
                    } else {
                        document.getElementById("collection_info").classList.add("d-none");
                    }
                } else {
                    this.shippingInfo = null;
                    document.getElementById("shipping_method_id").value = '';
                    document.getElementById("collection_info").classList.add("d-none");
                }
            } else {
                this.shippingInfo = null;
                document.getElementById("shipping_method_id").value = '';
                document.getElementById("collection_info").classList.add("d-none");
            }

        }
    },

    mounted() {
        this.$root.$on('deliveryAddressSelected', this.getShippingMethods);
    },

    methods: {
        getShippingMethods(addressId = null) {
            if (addressId) {
                this.addressId = addressId;
                axios.get('/api/v1/checkout/shipping-method/get/' + addressId)
                    .then(res => {
                        if (res.data && res.data.success) {
                            this.shippingMethods = res.data.shippingMethods;
                            this.hasUsed = res.data.hasUsed;
                            if (document.getElementById("shipping_method_id").value) {
                                this.selectedShippingMethodId = document.getElementById("shipping_method_id").value;
                                const activeMethod = this.shippingMethods.find(x => x.id == this.selectedShippingMethodId);
                                if (typeof activeMethod === 'undefined') {
                                    this.shippingInfo = null;
                                    this.selectedShippingMethodId = null;
                                    document.getElementById("shipping_method_id").value = '';
                                    document.getElementById("collection_info").classList.add("d-none");
                                }
                            }
                        }
                    })
                    .catch(error => {
                        //
                    })
                    .finally(res => {
                        this.loading = false;

                        if (this.shippingMethods.length == 0) {
                            this.showWarning = true;
                        } else {
                            this.showWarning = false;
                        }
                    });
            } else {
                this.addressId = null;
                this.shippingMethods = [];
                this.selectedShippingMethodId = null;
                this.loading = false;
                this.shippingInfo = null;
            }
        },
        updateTotalCostOnSelection(shippingMethodId) {
            // Different function from the Watch function so that it doesn't fire every page load

            const activeMethod = this.shippingMethods.find(x => x.id == shippingMethodId);

            let cost = document.getElementById('items').innerHTML;
            let totalItemCost = parseFloat(cost.replace('£', ''));
            let shippingCost = parseFloat(activeMethod.discount_price_inc_vat ? activeMethod.discount_price_inc_vat : activeMethod.price_inc_vat);

            // get card-vouchers id and see if it has free-delivery class
            const cardVouchers = document.getElementById('card-vouchers');
            let hasFreeDelivery = false;
            if (cardVouchers && cardVouchers.classList.contains('free-delivery')) {
                hasFreeDelivery = true;
            }

            if (hasFreeDelivery) {
                cardVouchers.classList.add('d-none');
            }

            if(activeMethod && activeMethod.price_inc_vat != '0.00') {
                document.getElementById('delivery-cost').innerHTML = currency(shippingCost, { symbol: "£", precision: 2 }).format();
                document.getElementById('total-cost').innerHTML = currency(shippingCost + totalItemCost, { symbol: "£", precision: 2 }).format();
            } else {
                document.getElementById('delivery-cost').innerHTML = 'FREE';
                document.getElementById('total-cost').innerHTML = document.getElementById('total-cost').innerHTML = document.getElementById('items').innerHTML;
            }
        }
    }
};
</script>
